import MantineContainer from "../mantine/container";
import MantineFlex from "../mantine/flex";
import MantineIcons from "../mantine/icons";
import MantinePaper from "../mantine/paper";
import { IconMenu2 } from "@tabler/icons-react";
import { useNavigate, useParams } from 'react-router-dom'; 
import HeaderuserProfileIcon from "../common/HeaderUserIcon";
import MantineImage from "../mantine/image";
import { Logo } from "../../helpers/common";

const VerticalTop = (props: any) => {
   const navigate = useNavigate();
  const { open, setOpen, currentPrimaryColor, isSmallScreenTablet, setMobileopen, mobileopen, handleColorfilterImage, logoMobile } = props;

  const handleMenuPress = () => {
    navigate("/profile");
  };
  const handleChangePassword = () => {
    navigate("/changepassword");
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };
  // Calculate width dynamically based on 'open' state
  const paperWidth = !open ? 'calc(100% - 250px)' : `${!isSmallScreenTablet ? 'calc(100% - 78px)' : `${!mobileopen ? 'calc(100% - 1px)' : 'calc(100% - 78px)'}`}`;

  return (
    <MantinePaper p={16} className={`!fixed z-50 `} style={{ width: paperWidth }}>
      <MantineContainer fluid={true}>
        <MantineFlex className="justify-between">
          {!isSmallScreenTablet ?
            <MantineIcons
              onClick={() => setOpen(!open)}
              iconComponent={!open ? IconMenu2 : IconMenu2}
              size={26}
              color={currentPrimaryColor}
              variant="transparent"
              stroke={1}
            /> :
            <MantineFlex>
              {!mobileopen &&
                <MantineImage
                  src={Logo}
                  className={`rounded-circle mr-2`}
                  height="40"
                  alt={""}
                  width={"40"}
                  style={{ filter: handleColorfilterImage?.filter }}
                />
              }
              <MantineIcons
                onClick={() => setMobileopen(!mobileopen)}
                iconComponent={!mobileopen ? IconMenu2 : IconMenu2}
                avtharClassName={`w-7 rounded-full`}
                size={26}
                color={currentPrimaryColor}
                variant="transparent"
                stroke={1}
              />
            </MantineFlex>
          }
          <div className={`absolute ${isSmallScreenTablet && !mobileopen ? 'right-2' : 'right-8'}`}>
            <MantineFlex gap={20}>
              <HeaderuserProfileIcon
                handleMenuPress={handleMenuPress}
                handleChangePassword={handleChangePassword}
                handleLogout={handleLogout}
              />
            </MantineFlex>
          </div>
        </MantineFlex>
      </MantineContainer>
    </MantinePaper>
  );
};
export default VerticalTop;
